import React, { useState, useEffect } from 'react';
import './Calendar.css';
import CurrentTime from '../components/CurrentTime';
import DynamicIsland from '../components/DynamicIsland';
import Back from '../components/Back';

function AcademicCalendar() {
  const [date, setDate] = useState(new Date());
  const [assignments, setAssignments] = useState({}); // State to hold assignment data

  // Sample function to fetch assignments from a JSON file
  useEffect(() => {
    // Assuming the JSON file is available at the public folder
    fetch('/classes.json')
      .then((response) => response.json())
      .then((data) => setAssignments(data))
      .catch((error) => console.error('Error loading events:', error));
  }, []); // Only run on mount

  // Format the selected date to match event keys (YYYY-MM-DD)
  const formattedDate = date.toISOString().split('T')[0];

  // Function to group assignments by class and sort them alphabetically
  const groupByClass = (events) => {
    const grouped = {};

    // Group assignments by class
    events.forEach((event) => {
      if (!grouped[event.class]) {
        grouped[event.class] = [];
      }
      grouped[event.class].push(event);
    });

    // Sort classes alphabetically and return sorted assignments
    const sortedGrouped = Object.keys(grouped).sort().reduce((result, className) => {
      result[className] = grouped[className];
      return result;
    }, {});

    return sortedGrouped;
  };

  const eventsForToday = assignments[formattedDate] || [];
  const groupedAndSortedEvents = groupByClass(eventsForToday);

  // Function to generate the current month's calendar
  const generateCalendar = () => {
    const startOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
    const endOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    const daysInMonth = endOfMonth.getDate();

    // Find the first day of the week of the first day of the month
    const startDay = startOfMonth.getDay();

    // Generate an array of days to display in the calendar
    const calendarDays = [];
    for (let i = 1; i <= daysInMonth; i++) {
      const currentDay = new Date(date.getFullYear(), date.getMonth(), i);
      calendarDays.push(currentDay);
    }

    return calendarDays;
  };

  const calendarDays = generateCalendar();

  return (
    <div className="academic-container">
      <CurrentTime />
      <DynamicIsland />
        <Back />

      <div className="calendar-container">
        <h2>{date.toDateString()}</h2>
        <div className="calendar">
          <div className="calendar-header">
            <button className="calendar-button-prev" onClick={() => setDate(new Date(date.getFullYear(), date.getMonth() - 1))}>Prev</button>
            <button className="calendar-button-next" onClick={() => setDate(new Date(date.getFullYear(), date.getMonth() + 1))}>Next</button>
          </div>
          <div className="calendar-grid">
            {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map((day, idx) => (
              <div key={idx} className="calendar-day-name">{day}</div>
            ))}
            {Array.from({ length: (calendarDays[0].getDay()) }).map((_, idx) => (
              <div key={idx} className="calendar-day empty"></div>
            ))}
            {calendarDays.map((day, idx) => (
              <div
                key={idx}
                className={`calendar-day ${day.toISOString().split('T')[0] === formattedDate ? 'selected' : ''}`}
                onClick={() => setDate(day)}
              >
                {day.getDate()}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Assignments Section */}
      <div className="assignments-section">
        {Object.keys(groupedAndSortedEvents).length > 0 ? (
          Object.keys(groupedAndSortedEvents).map((className) => (
            <div key={className} className="class-section">
              <h4>{className}</h4>
              {groupedAndSortedEvents[className].map((assignment, index) => (
                <div key={index}>
                  <strong>{assignment.assignment}:</strong> <em>{assignment.time}<br/>
                  {assignment.description}
                  </em>
                </div>
              ))}
            </div>
          ))
        ) : (
          <p>No assignments for this day.</p>
        )}
      </div>
    </div>
  );
}

export default AcademicCalendar;